// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import Loader from '../../elements/Loader';
import LoadFailed from '../../elements/LoadFailed';
import ErrorCapsule from '../../core/exceptions/ErrorCapsule';
import OfflineTabsView from './OfflineTabsView';

export type OfflineBranch = {
  officeId: string,
  officeName: string,
  isOnline: boolean,
  lastSeenAt: ?string,
  lastSyncAt: ?string,
  appVersion: ?string,
  deviceInfo: ?string,
  tokenIsActive: boolean,
  lastDate: ?string,
  cutsLastDay: number,
}

export type OfflineBranchesPageViewProps = {
  branches: null | Array<OfflineBranch> | ErrorCapsule,
  onRefresh: () => void,
}

// «Минуту назад» читается быстрее, чем время: смотрят на эту страницу, чтобы
// понять, жив ли филиал прямо сейчас.
function ago(value: ?string) {
  if (!value) return '—';
  const seconds = Math.round((Date.now() - new Date(value).getTime()) / 1000);
  if (seconds < 60) return 'только что';
  if (seconds < 3600) return `${Math.floor(seconds / 60)} мин назад`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} ч назад`;
  return new Date(value).toLocaleString('ru-RU');
}

export default function OfflineBranchesPageView({ branches, onRefresh }: OfflineBranchesPageViewProps) {
  return (
    <div className="offline-branches">
      <h1>Офлайн-каттер</h1>
      <OfflineTabsView />

      {!branches ? <Loader /> : branches instanceof ErrorCapsule ? <LoadFailed error={branches} /> : (
        <>
          <div className="mb-1 text-right">
            <button type="button" className="btn btn-secondary btn-sm" onClick={onRefresh}>Обновить</button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Филиал</th>
                  <th>Связь</th>
                  <th>Последний раз</th>
                  <th>Версия</th>
                  <th>Последний день</th>
                </tr>
              </thead>
              <tbody>
                {branches.length === 0 ? (
                  <tr><td colSpan={5} className="text-center text-muted">Ни один филиал ещё не выходил на связь</td></tr>
                ) : branches.map((branch) => (
                  <tr key={branch.officeId}>
                    <td>
                      {/* Имя — ссылка на резы этого филиала, отдельной кнопки не держим */}
                      <Link to={`/offline/cuts/${branch.officeId}`}>{branch.officeName}</Link>
                      {branch.tokenIsActive ? null : <span className="badge badge-secondary ml-1">токен отозван</span>}
                      {branch.deviceInfo ? <div className="small text-muted">{branch.deviceInfo}</div> : null}
                    </td>
                    <td>
                      {branch.isOnline
                        ? <span className="badge badge-success">Онлайн</span>
                        : <span className="badge badge-secondary">Офлайн</span>}
                    </td>
                    <td className="text-nowrap">{ago(branch.lastSeenAt)}</td>
                    <td>{branch.appVersion || '—'}</td>
                    <td className="text-nowrap">
                      {branch.lastDate
                        ? <>{branch.lastDate} <span className="text-muted">·</span> {branch.cutsLastDay} рез.</>
                        : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
